import { all } from "redux-saga/effects";
import { authSaga, flightSaga, locationSaga, additionalSaga } from "./";

export default function* rootSaga() {
  yield all([authSaga(), flightSaga(), locationSaga(), additionalSaga()]);
}
